import dynamic from "next/dynamic"
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });
import { InformationRequest } from "../../web";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";

export const ModalConsulta = ({
	modal,
	owner, 
	isAuthModalShowing, 
	closeModal, 
	id, 
	defaultMessage, 
	onSuccess, 
	isProject,
	isExpress = null,
	expressCallback = null,
	propertyLink
}) => {
	const { ctaButtons } = useContactModal();
	const modalTitle = ctaButtons?.phone ? "Ver teléfono" : ctaButtons?.whatsapp ? "Ver Whatsapp" : isExpress ? "Enviar consulta" : "Contactar al anunciante";

	return (
		<>
			<Modal onClose={closeModal} show={modal && !isAuthModalShowing} title={modalTitle} width="540px" customIndex={1001}>
				<div className="form-modal">
					<div className="auth-modal">
						<InformationRequest
							onComplete={onSuccess}
							id={id}
							owner={owner}
							defaultMessage={defaultMessage}
							isInListing={false}
							isProject={isProject}
							isFromModal
							source="contactModal"
							isExpress={isExpress}
							expressCallback={expressCallback}
							propertyLink={propertyLink}
							ctaToShow={ctaButtons}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
}